<template>

  <div class="fullscreen center-flex">
  	<select class="select" v-model="selectedLevel" placeholder="Select level" @change="handleChange">
      <option :value="null">Select level</option>
  		<option v-for="level, id in levels" :key="id" :value="id">{{ level }}</option>
  	</select>
  	<button class="button" @click="handleClick" :disabled="buttonDisabled">START</button>
  </div>

</template>

<script>
export default {

  name: 'Start',

  components: {

  },

  data() {

    return {
    	levels: [
    		'Level 1',
    		'Level 2',
    		'Level 3'
    	],
    	selectedLevel: null,
      gameStarted: false,
    }
  },

  computed: {
  	buttonDisabled() {
  		return this.selectedLevel === null
  	},
  },

  methods: {
    handleClick() {
  		this.$bus.emit('app:game-started', this.selectedLevel)
    },
  	handleChange(e) {
      this.selectedLevel = e.target.value
  	},
  },
}
</script>

<style lang="css" scoped>
 .fullscreen {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: white;
  background-image: url('../assets/keyboard_warrior_3.png'); /* Path to your image */
  background-size: cover; /* This will ensure that the background covers the entire viewport */
  background-position: center; /* This centers the background image */
  background-repeat: no-repeat; /* This will prevent the image from repeating */
  background-attachment: fixed; /* This will make sure that the background is fixed when scrolling */
  z-index: 9;
}
.center-flex {
  display: flex;
  flex-direction: column; /* Stack items vertically */
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  height: 100vh; /* Full height of the viewport */
}
/* Button styling */
.button {
  position: relative;
  top: 280px;
  cursor: pointer;
  font-size: 67px;
  padding: 20px 120px; /* Optional: Adjust the padding */
  text-align: center; /* Optional: Center the text inside the button */
  margin-top: 0px; /* Add some space between the select box and the button */
  /* Add other styles for your button here */
}
.select {
  position: relative;
  top: 280px;
  width: 30%; /* Adjust the width as per your design */
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-weight: bold;
  font-size: 2em;
  color: #333;
  background-color: #fff;
  cursor: pointer;
  margin-bottom: 20px; /* This will add space below the select box */
}
</style>
